"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

var _knotchincWebReactComponents2 = require("@bit/knotchinc.web-react-components.tooltip");

var _Utils = require("./helpers/Utils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellDemographics = function CellDemographics(props) {
  var data = props.data,
      header = props.header,
      headerText = props.headerText,
      hidePercentage = props.hidePercentage,
      handleClick = props.handleClick,
      highlighted = props.highlighted,
      width = props.width,
      sorted = props.sorted,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      _props$printView = props.printView,
      printView = _props$printView === void 0 ? false : _props$printView;
  var percentage = !hidePercentage;

  if (!header && !((0, _Utils.validateString)(data.top_gender) && (0, _Utils.validateString)(data.top_age_group))) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    width: width,
    onClick: handleClick,
    sortable: sortable,
    sortOrder: sortOrder,
    sorted: sorted
  }, headerText, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents2.TooltipWithIcon, {
    iconSize: "small",
    type: "demographics"
  })) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    highlited: highlighted,
    width: width,
    sorted: sorted
  }, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    padding: "5px 10px",
    mb: "2px"
  }, "".concat((0, _Utils.capitalizeString)(data.top_gender), " "), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    color: "#939AAB",
    display: "inline"
  }, percentage ? (0, _Utils.inPercent)(data.pct_top_gender) : '')), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    fontSize: printView ? '8px' : '10px'
  }, "".concat((0, _Utils.capitalizeString)(data.top_age_group), " "), /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
    color: "#939AAB",
    display: "inline",
    textAlign: "left"
  }, percentage ? (0, _Utils.inPercent)(data.pct_top_age_group) : '')));
};

CellDemographics.defaultProps = {
  data: {}
};
var _default = CellDemographics;
exports["default"] = _default;

//# sourceMappingURL=CellDemographics.js.map